import { UpdateMultiStandardMutationProvider } from "__legacy/queries/projects/UpdateMultiStandardMutationProvider";
import { Button, Card, Col, Drawer, Form, Row, Space } from "antd";
import { Fragment, useState } from "react";
import { useParams } from "react-router";

import { onFinish, PwsMultiStandardForm } from "./PwsMultiStandardForm";

type PwsMultiStandardCardType = {
  project: any;
  editable: boolean;
};

export const PwsMultiStandardCard: React.FC<PwsMultiStandardCardType> = (props) => {
  const { project, editable } = props;
  const { id } = useParams();
  const title = "Multi Standard";
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  const [drawerVisible, setDrawerVisible] = useState(false);
  const onClose = () => setDrawerVisible(false);

  const [Mutation, params, variables] = [UpdateMultiStandardMutationProvider, {}, { id }];

  const onError = () => ({ graphQLErrors }: any) => {
    const errors: string[] = [];
    graphQLErrors.forEach((graphQLError: any) => {
      errors.push(graphQLError.message);
    });
    setErrors(errors);
  };

  const filled = project.multiStandardFilled;

  return (
    <Fragment>
      <Card
        title={title}
        bodyStyle={filled ? {} : { display: "none" }}
        extra={
          editable && (
            <Button type={filled ? "ghost" : "primary"} onClick={() => setDrawerVisible(true)}>
              {filled ? "Edit" : "Fill"}
            </Button>
          )
        }
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            Reduction:{" "}
            {project.multiStandard && (
              <b>
                <Space>
                  <span>{project.multiStandardPercentage}%</span>
                  {project.multiStandardReason}
                </Space>
              </b>
            )}
            {!project.multiStandard && <b>No</b>}
          </Col>
        </Row>
      </Card>
      <Mutation onError={onError}>
        {(loading, mutate) => (
          <Drawer
            title={title}
            width={680}
            onClose={onClose}
            visible={drawerVisible}
            keyboard={false}
            maskClosable={false}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button onClick={onClose} style={{ marginRight: 8 }}>
                  Cancel
                </Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </div>
            }
          >
            <PwsMultiStandardForm
              form={form}
              project={project}
              onFinish={onFinish(mutate, params, variables)}
              errors={errors}
            />
          </Drawer>
        )}
      </Mutation>
    </Fragment>
  );
};
